import { render, staticRenderFns } from "./activeSalary.vue?vue&type=template&id=08f246d8&scoped=true"
import script from "./activeSalary.vue?vue&type=script&lang=js"
export * from "./activeSalary.vue?vue&type=script&lang=js"
import style0 from "./activeSalary.vue?vue&type=style&index=0&id=08f246d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f246d8",
  null
  
)

export default component.exports